import { Component, Input, ElementRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { UploadOutput, UploadInput, UploadFile } from '../../../ngx-uploader/classes/ngx-uploader.class';


@Component({
  moduleId: module.id,
  selector: 'drag-assets-space',
  templateUrl: 'drag-assets-space.component.html',
  styleUrls: ['drag-assets-space.component.scss'],
})
export class DragAssetsSpaceComponent {
  // ngx-uploader docs https://github.com/bleenco/ngx-uploader
  @Input() mimetypes: string;
  @Input() uploadInput: EventEmitter<UploadInput>;
  @Input() fullScreen: boolean = false;
  @Input() dropOutside: boolean = false;
  @Input() isEditable: boolean = false;

  @HostBinding('class.is-drag-over')
  @Input() dragOver: boolean = false;

  @Output() filesChange: EventEmitter<any> = new EventEmitter();
  @Output() uploadOutput: EventEmitter<UploadOutput> = new EventEmitter<UploadOutput>();
  @Output() saveClick: EventEmitter<any> = new EventEmitter();

  @ViewChild('filesInput', {static: false})
  filesInput: ElementRef | void;


  onFileAccept() {
    if (this.filesInput) {
      this.filesInput.nativeElement.click();
    }
  }

  onFilesChange(event: any) {
    this.filesChange.emit(event.currentTarget.files);
  }

  onUploadOutput(output: UploadOutput) {
    if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.uploadOutput.emit(output);
  }

  onSave($event: MouseEvent) {
    $event.stopPropagation();
    if (!this.isEditable) {
      return;
    }
    this.saveClick.emit();
  }

  public clearData(): void {
    if (this.filesInput) {
      this.filesInput.nativeElement.value = '';
    }
  }
}
